export const generateEngagementScaleOptions = (maxOptions: number) =>
  Array.from({ length: maxOptions }).map((_, i) => ({
    score: i + 1,
    displayOption: i + 1,
    description: '',
  }));
